import { NgModule } from '@angular/core';
import { CommonModule } from 'app/common.module';
import { ClickOutsideModule } from 'ng-click-outside';

import { SidebarNavModule } from 'shared/components/sidebar-nav/sidebar-nav.module';

import { SidebarNavComponent } from 'app/components/app-common-views/sidebar-nav/sidebar-nav.component';

@NgModule({
  imports: [ClickOutsideModule, CommonModule, SidebarNavModule],
  exports: [SidebarNavComponent],
  declarations: [SidebarNavComponent],
  providers: [],
})
export class SidenavBarModule {}
